// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"31":"99c0ae16d7c2a9df","367":"cc3097ca5d54df9a","412":"ff6239d802b99edf","543":"0cd6ce6b09f9261a","667":"52f9b57f952cd426","755":"2b0f22c61c3f468b","775":"01c54f40944540ce"}[chunkId] + ".js";
};